import { Divider, Flex, Pagination, PaginationProps } from 'antd';
import CustomLoader from 'components/CustomLoader';
import TagComponent from 'components/Tags';
import { TDashboard } from 'hooks/useDashboardQuery';
import { useTranslation } from 'react-i18next';
import { getStatusTagColor } from 'screens/farmer/helper';
import { TaskAssignment } from 'types/common';
import { renderDate } from 'utils/helpers';
import { SelectTaskData } from '../../sales-group-progress';
import TaskStatusList from './TaskStatusList';

type MobileDashboardTableProps = PaginationProps & {
  data: TDashboard[] | null;
  loading?: boolean;
  onSelectTask: (data: SelectTaskData) => void;
  onSelectRow: (data: TDashboard) => void;
  isSalesGroup?: boolean;
};

const MobileDashboardTable = ({
  data,
  onSelectTask,
  loading = false,
  onSelectRow,
  isSalesGroup = false,
  ...props
}: MobileDashboardTableProps) => {
  const { t } = useTranslation();

  return (
    <>
      {loading && (
        <div className="loader-container">
          <CustomLoader size="extra-large" />
        </div>
      )}
      <Flex vertical gap={10}>
        {data?.map((d) => (
          <div
            className="base-card dashboard-mobile-card"
            key={d?.season?.id}
            style={{ boxShadow: 'none' }}
          >
            <Flex vertical gap={12}>
              <Flex
                justify="space-between"
                align="center"
                onClick={() => onSelectRow(d)}
              >
                <span className="text-base text-strong">
                  {d?.agronomistName}
                </span>
                <TagComponent
                  label={d?.season?.status || 'Inactive'}
                  color={getStatusTagColor(d?.season?.status)}
                />
              </Flex>
              <Flex justify="space-between" align="center">
                <span className="text-tertiary text-small">
                  {isSalesGroup
                    ? t('salesGroups.salesGroupName')
                    : t('dashboard.plantingGroupName')}
                </span>
                <span className="info-value">{d?.season?.name}</span>
              </Flex>
              <Flex justify="space-between" align="center">
                <span className="text-tertiary text-small">
                  {t('salesGroups.estHarvestDate')}
                </span>
                <span className="info-value">
                  {renderDate(d?.season?.estimatedEndDate)}
                </span>
              </Flex>
              <Divider style={{ margin: 0 }} />
              <Flex justify="space-between" align="center">
                <span className="text-tertiary text-small">
                  {t('dashboard.taskStatus')}
                </span>
                <TaskStatusList
                  tasks={d?.season?.tasks}
                  onClickTask={(task: TaskAssignment) =>
                    onSelectTask({
                      ...d,
                      task,
                      season: d.season,
                    })
                  }
                />
              </Flex>
            </Flex>
          </div>
        ))}
      </Flex>
      <Pagination style={{ marginTop: '20px' }} align="end" {...props} />
    </>
  );
};

export default MobileDashboardTable;
